<form [formGroup]="form" class="time-entry-player">
  <div class="time-entry-player__title">Track your time</div>

  <div class="time-entry-player__container">
    <div class="time-entry-player__row">
      <!-- Task input field with autocomplete -->
      <div class="time-entry-player__field time-entry-player__field--text">
        <mat-form-field appearance="fill" class="filters-form-field">
          <mat-label>What are you working on?</mat-label>
          <mat-icon matPrefix class="me-1">edit</mat-icon>
          <input 
            matInput 
            formControlName="inputText" 
            [matAutocomplete]="auto"
            placeholder="Enter task description">
          <mat-error *ngIf="form.get('inputText')?.hasError('required') && form.get('inputText')?.touched">
            Task description is required
          </mat-error>
        </mat-form-field>
        <mat-autocomplete #auto="matAutocomplete">
          @for (option of (filteredOptions | async); track option) {
            <mat-option [value]="option">{{option}}</mat-option>
          }
        </mat-autocomplete>
      </div>

      <div class="time-entry-input__field time-entry-input__field--tags">
        <select-list #selectListTags [optionList]="optionsFromTags" [multiple]="true" [searchBar]="true" label="Tags" icon="local_offer" (selectedOptionsChanged)="form.get('selectedTags')?.setValue($event)" />
      </div>

      <div class="time-entry-input__field time-entry-input__field--tags">
        <select-list #selectListProjects [optionList]="optionsFromProjects" [searchBar]="true" label="Projects" icon="folder" (selectedOptionChanged)="form.get('selectedProject')?.setValue($event)" />
      </div>

      <!-- Timer display -->
      <div class="time-entry-player__field time-entry-player__field--timer">
        <div class="time-entry-player__timer-display" aria-label="Elapsed time">
          {{ formatElapsedTime() }}
        </div>
      </div>

      <!-- Play/pause button -->
      <div class="time-entry-player__field time-entry-player__field--actions">
        <button 
          mat-mini-fab 
          color="primary" 
          (click)="toggleTimer()" 
          [disabled]="!form.valid"
          [attr.aria-label]="timerOn ? 'Pause timer' : 'Start timer'">
          <mat-icon>{{ timerOn ? 'pause' : 'play_arrow' }}</mat-icon>
        </button>
      </div>
    </div>
  </div>
</form>
